import React from 'react'
import { Box } from '@material-ui/core'

import { DaiControlSection, Smtp } from './components'

import useFetch from 'hooks/useFetch'
import usePermissions from 'hooks/usePermissions'
import useDaiOptOut from 'hooks/useDaiOptOut'

import constants from 'constants/index'
import * as service from 'service'

const AdvancedSettings = () => {
  const permissions = usePermissions()
  const { isLoadingStart: isDaiOptOutLoading } = useDaiOptOut()

  const smtpPermissions = permissions.permitted(
    constants.permissions.SMTP_CREDENTIAL.MANAGE,
  )

  const { response, isLoading, refresh } = useFetch(
    service.dponet.smtp.show,
    {},
    [],
    !!smtpPermissions,
  )

  const smtpCredential = response?.data?.smtpCredential

  return (
    <Box>
      <Smtp
        key={isLoading ? 'smtp-loading' : 'smtp-loaded'}
        smtpCredential={smtpCredential}
        isLoading={isLoading}
        refresh={refresh}
      />
      <DaiControlSection
        key={
          isDaiOptOutLoading
            ? 'dai-control-section-loading'
            : 'dai-control-section'
        }
      />
    </Box>
  )
}

export default AdvancedSettings
